import { Component, Host, h, Prop, Element, Listen, State } from '@stencil/core';
import { getPlatforms } from '@baloise/ds-core';
import { BamJobSearchItem } from './bam-job-search-item';
import { DataService } from '../../utils/data-service.service';
import { loadApi } from '../../utils/google-maps.service';

@Component({
  tag: 'bam-job-search',
  styleUrl: 'bam-job-search.scss',
  shadow: false,
})
export class BamJobSearch {
  @Element() el: HTMLElement;
  @Prop() formName: string;
  @Prop() method: string = 'GET';
  @Prop() action: string;
  @Prop() ajax: boolean;
  @Prop() hideWidget: boolean;
  @Prop() hideResultCounter: boolean;
  @Prop() withBackground: boolean;
  @Prop() backgroundColor?: string;
  @Prop() loadMoreBtnText: string;
  @Prop() noResultText: string;
  @Prop() resultTextPlaceholder: string;
  @Prop() resultTextSuffix: string;
  @Prop() loadingText: string;
  @Prop() widgetTitle?: string;
  @Prop() displayLimit: number;
  @State() viewport: string;
  form!: HTMLFormElement;
  loadMoreBtn!: HTMLBalButtonElement;
  @State() results: any[];
  @State() items: any[];
  private resultText: string;
  private isLoading: boolean = true;
  private queryString: URLSearchParams;
  private page: number = 0;
  private nextPage: boolean;
  private geoLat: number;
  private geoLng: number;
  private trackingEvent: any;
  private queryStringInput: HTMLInputElement;
  private reset: boolean = false;

  @Listen('fillInAddressEvent')
  onFillInAddressEvent(event) {
    if (!this.reset) {
      if (event.detail) {
        this.queryString = new URLSearchParams(new FormData(this.form) as any);
        if (this.ajax && event.target.id !== 'autocomplete') {
          if (event.detail['reset']) {
            this.geoLat = null;
            this.geoLng = null;
          } else {
            this.geoLat = event.detail['lat'];
            this.geoLng = event.detail['lng'];
            this.queryString.set('geoLat', this.geoLat.toString());
            this.queryString.set('geoLng', this.geoLng.toString());
            setTimeout(() => this.requestData(this.action + '?' + this.queryString), 200);
          }
        }
      } else if (event.detail === '') {
        this.geoLat = null;
        this.geoLng = null;
      }
    }
  }

  @Listen('balChange')
  onBalChange(event) {
    this.trackingEvent = event;
    if (!this.reset) {
      if (this.ajax && event.target.id !== 'autocomplete') {
        setTimeout(() => this.getData(), 200);
      } else if (event.target.id === 'autocomplete') {
        if (event.detail === '') {
          this.geoLat = null;
          this.geoLng = null;
          setTimeout(() => this.getData(), 200);
        }
      }
    }
    setTimeout(() => {
      this.dataLayerPush();
    }, 300);
  }

  @Listen('reset')
  onReset(event) {
    event.preventDefault();
    if (!this.reset) {
      this.trackingEvent = undefined;
      this.reset = true;
      const balInputs = this.el.querySelectorAll(
        'bal-input, bal-textarea, bal-radio-group, bal-dropdown, bal-checkbox, bal-checkbox-group, bal-date',
      ) as NodeListOf<HTMLBalInputElement>;

      setTimeout(() => {
        balInputs.forEach(input => {
          if (input.name !== 'select-radius') {
            if (input.hasAttribute('value')) {
              input.setAttribute('value', '');
            }
            if (input.hasAttribute('data-value')) {
              input.setAttribute('data-value', '');
              input.setAttribute('value', '');
            }
            if (input.hasAttribute('checked')) {
              input.setAttribute('checked', 'false');
            }
          }
        });
        this.geoLat = null;
        this.geoLng = null;
        setTimeout(() => {
          this.reset = false;
          if (this.ajax) {
            this.getData();
          }
        }, 200);
      }, 17);
    }
  }

  componentWillLoad() {
    this.viewport = getPlatforms()[0];
    this.results = [];
    this.items = [];
  }

  componentDidLoad() {
    this.queryStringInput = this.el.querySelector(`input[name="query-str"]`);
    loadApi;
    setTimeout(() => {
      if (this.ajax) {
        this.getData();
      }
    }, 200);
  }

  @Listen('resize', { target: 'window' })
  onResizeWindow() {
    const currentViewport = getPlatforms()[0];
    if (currentViewport !== this.viewport) {
      this.viewport = currentViewport;
    }
  }

  handleSubmit = event => {
    // console.log('handleSubmit', 'event', event);
    event.preventDefault();
    setTimeout(() => {
      this.getData();
    }, 100);
  };

  handleLoadMore = () => {
    this.page = this.page + 1;
    this.items = this.items.concat(this.results[this.page].items);
    this.nextPage = this.results.length > this.page + 1;
  };

  dataLayerPush() {
    if (this.trackingEvent) {
      const searchTerm = this.queryStringInput.value;
      let searchFilterLabel = this.trackingEvent.target.dataset.trackingLabel;
      let searchFilterValue = this.trackingEvent.target.dataset.value;

      if (this.trackingEvent.target.dataset.trackingLabel === 'searchTerm') {
        searchFilterLabel = '';
      }

      if (this.trackingEvent.target.id === 'autocomplete') {
        searchFilterValue = this.trackingEvent.target.querySelector('input').value;
      } else if (this.trackingEvent.target.name === 'home-office') {
        searchFilterValue = this.trackingEvent.target.checked.toString();
      }

      let dataObj = {
        event: 'searchPerformed',
      };
      dataObj['searchTerm'] = searchTerm ? searchTerm : '';
      searchFilterLabel ? (dataObj['searchFilterLabel'] = searchFilterLabel) : '';
      searchFilterValue ? (dataObj['searchFilterValue'] = searchFilterValue) : '';

      window.localStorage.getItem('dataLayerObject') === 'true' && console.table(dataObj);
      window.dataLayer.push(dataObj);
      this.trackingEvent = undefined;
    }
  }

  balList() {
    return (
      <bal-list border={true}>
        {this.items.map(item => (
          <BamJobSearchItem batch={item.batch} href={item.href} subTitle={item.subTitle} title={item.title} buttonText={item.buttonText}></BamJobSearchItem>
        ))}
      </bal-list>
    );
  }

  getLoadingText() {
    return (
      <bal-text bold color="info" size="block" class="flex justify-content-center">
        {this.loadingText}
      </bal-text>
    );
  }

  getNoResultText() {
    return (
      <bal-text bold color="info" size="block" class="flex justify-content-center">
        {this.noResultText}
      </bal-text>
    );
  }

  getResultText() {
    return (
      <bam-job-search-result-counter>
        <bal-text heading bold inline color="primary">
          {this.resultText}
        </bal-text>
        <bal-text inline color="primary">
          {' '}
          {this.resultTextSuffix}
        </bal-text>
      </bam-job-search-result-counter>
    );
  }

  async getData() {
    this.queryString = await new URLSearchParams(new FormData(this.form) as any);
    setTimeout(() => {
      if (this.ajax) {
        this.requestData(this.action + '?' + this.queryString);
      } else {
        if (this.queryString.get('search-widget-radius-select-country') === null) {
          this.queryString.set('search-widget-radius-select-country', 'all');
        }
        setTimeout(() => {
          location.href = location.origin + this.action + '?' + this.queryString;
        }, 100);
      }
    }, 1);
  }

  lookup(item, item2) {
    const radius = Number(this.queryString.get('select-radius')) * 1000;
    if (item.coords && item2.coords) {
      const latlng = new google.maps.LatLng(item.coords.lat, item.coords.lng);
      const latlng2 = new google.maps.LatLng(item2.coords.lat, item2.coords.lng);
      const distance = google.maps.geometry.spherical.computeDistanceBetween(latlng, latlng2);

      const distanceFormatted = `${new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 1,
      }).format(distance / 1000)} km`;

      item2.distance = distance;
      item2.distanceFormatted = distanceFormatted;

      return distance <= radius;
    }
  }

  requestData(requestUrl: string) {
    // console.log('requestData', requestUrl);
    DataService.getData(requestUrl).then(data => {
      this.page = 0;
      let results = data.results;
      if (data.error) {
        this.resultText = data.text;
        this.isLoading = false;
        this.items = [];
        this.results = [];
        this.nextPage = false;
      }
      if (results && results.length) {
        let counterTmp = 0;
        if (this.geoLng && this.geoLat && this.queryString.get('select-radius')) {
          let resultsTmp = [];
          let resultTmp = [];
          results.map(result => {
            resultTmp = [
              ...resultTmp,
              ...result.items.filter(item => {
                return this.lookup(
                  {
                    coords: {
                      lat: this.geoLat,
                      lng: this.geoLng,
                    },
                  },
                  item,
                );
              }),
            ];
            if (resultTmp.length >= 10) {
              resultsTmp = [...resultsTmp, { items: resultTmp.splice(0, 10) }];
              counterTmp += 10;
            }
          });
          if (resultTmp.length > 0) {
            resultsTmp = [...resultsTmp, { items: resultTmp }];
            counterTmp += resultTmp.length;
          }
          this.resultText = this.resultTextPlaceholder.replace('{0}', counterTmp.toString());
          this.results = resultsTmp;
        } else {
          this.resultText = data.text;
          this.results = results;
        }
        this.isLoading = false;
        this.nextPage = this.results.length > this.page + 1;
        this.items = this.results[0]?.items;
      }
    });
  }

  render() {
    const backgroundColor = this.backgroundColor ? `is-${this.backgroundColor} ` : '';
    return (
      <Host>
        <form
          enctype="multipart/form-data"
          onSubmit={this.handleSubmit}
          ref={el => (this.form = el as HTMLFormElement)}
          name={this.formName}
          method={this.method}
          action={this.action}
          class={`
              ${this.withBackground && 'bam-job-search-background'}
              ${backgroundColor}
              ${this.hideWidget && 'hidden'}
              `}
          noValidate
        >
          {this.widgetTitle && (
            <bal-heading level={'h2'} class={'is-widget-title mb-x-large mt-large'}>
              {this.widgetTitle}
            </bal-heading>
          )}
          <slot name="filter"></slot>
        </form>

        <div class="mt-x-large pt-x-small">
          {this.isLoading && this.ajax && (
            <div class={'flex justify-content-center'}>
              <bal-spinner></bal-spinner>
            </div>
          )}
          {this.isLoading && this.ajax && this.getLoadingText()}
          {!this.hideResultCounter && !this.isLoading && (this.results && this.results.length ? this.getResultText() : '')}
          {!this.isLoading && (this.results && this.results.length ? this.balList() : this.getNoResultText())}
        </div>

        {!this.isLoading && this.nextPage && this.results && this.results.length > 0 && (
          <bal-button-group position="center" id="result-load-more">
            <bal-button ref={el => (this.loadMoreBtn = el as HTMLBalButtonElement)} color="primary-light" class="mt-xx-large" onClick={this.handleLoadMore}>
              {this.loadMoreBtnText}
            </bal-button>
          </bal-button-group>
        )}
      </Host>
    );
  }
}
